import React from 'react';
import Box from '../../styled/Box';
import { H4 } from '../../styled/Heading';
import { StyledLink } from '../../styled/Link';
import Text from '../../styled/Text';
import Link from '../../Router/Link';
import WarningIcon from '../../assets/varning-delbetalning.svg';
import { CreditWarningIcon } from './wrapper';

interface ICreditWarning {
  boxed: boolean;
}

const CreditWarning = ({ boxed }: ICreditWarning) => {
  const content = (
    <>
      <CreditWarningIcon src={WarningIcon} />
      <H4>Att låna kostar pengar!</H4>
      <Text>
        Om du inte kan betala tillbaka skulden i tid riskerar du en betalningsanmärkning. Det kan
        leda till svårigheter att få hyra bostad, teckna abonnemang och få nya lån. För stöd, vänd
        dig till budget- och skuldrådgivningen i din kommun. Kontaktuppgifter finns på{' '}
        <Link
          Component={StyledLink}
          href={'https://www.konsumentverket.se/ekonomi/kommunal-budget-och-skuldradgivning/'}
          title={`konsumentverket.se`}>
          konsumentverket.se
        </Link>
        .
      </Text>
    </>
  );

  return boxed ? (
    <Box background="main" overhang="mobile" rounded>
      {content}
    </Box>
  ) : (
    content
  );
};

export default CreditWarning;
